<template>
  <div>
    <icon v-if="icon" :name="icon" style="margin-right:8px" />
    <span v-if="title" slot='title'>{{title}}</span>
  </div>
</template>
<script>
export default {
  name: 'MenuItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
}
</script>
